const Component = require('choo/component');
const html = require('choo/html');
const {
  unselectedAnswerStyle,
  selectedAnswerStyle,
  uncenteredUnselectedAnswerStyle,
  uncenteredSelectedAnswerStyle,
  stickToBottom,
  bgCorrectAnswer,
  bgWrongAnswer,
  textCorrectAnswer,
  textWrongAnswer,
  questionTextStyle
} = require('../lib/styles');

const selectButtonStyle =
  'f3 navy bg-dt-white justify-center flex flex-auto items-center bg-animate ttu ti-sans-b noselect';

const selectedSelectButtonStyle =
  'f3 dt-white bg-dt-blue justify-center flex flex-auto items-center bg-animate ttu ti-sans-b noselect';

class MultiselectMultipleChoice extends Component {
  constructor(emit) {
    super();
    // this.local = state.components[id] = {};
    this.state = {
      selectedAnswers: new Set()
    };

    this.emit = emit;
    // this.answerClick = this.answerClick.bind(this);
    // this.answerSubmit = this.answerSubmit.bind(null);
  }

  answerClick(choice) {
    if (this.state.singleAnswer) {
      if (this.state.selectedAnswers.has(choice)) {
        this.state.selectedAnswers.delete(choice);
      } else {
        this.state.selectedAnswers = new Set([choice]);
      }
    } else {
      if (this.state.selectedAnswers.has(choice)) {
        this.state.selectedAnswers.delete(choice);
      } else {
        this.state.selectedAnswers.add(choice);
      }
    }

    this.render(this.state);
  }

  answerSubmit() {
    this.emit(
      'quiz:answer',
      this.state.id,
      [...this.state.selectedAnswers].sort().join(',')
    );
  }

  nextQuestion() {
    this.emit('quiz:nextQuestion');
  }

  createElement(question) {
    this.state = Object.assign({}, question, this.state);

    return html`
      <div>
        <div class="pa3">
          ${this.state.chosenAnswer !== undefined
            ? ''
            : html`
                <section class="${questionTextStyle}">
                  ${this.state.question}
                </section>
              `}
          ${this.state.chosenAnswer !== undefined
            ? html`
                <div
                  class="pa3 f2 mw6-ns center ${this.state.correct
                    ? bgCorrectAnswer
                    : bgWrongAnswer}"
                >
                  <img
                    src="../assets/${this.state.correct
                      ? 'check-blue'
                      : 'x-red'}.svg"
                  />

                  ${this.state.correct
                    ? html`
                        <span class="${textCorrectAnswer}">Correct</span>
                      `
                    : html`
                        <span class="${textWrongAnswer}">Wrong</span>
                      `}
                  ${this.state.chosenAnswer !== undefined
                    ? html`
                        <div class="f5 f3-ns lh-title pt2">
                          ${this.state.explanation}
                        </div>
                      `
                    : ''}
                </div>
              `
            : html`
                <div class="overflow-scroll overflow-scroll-touch">
                  <ul
                    class="list pa0 ma0 flex items-stretch"
                    style="width: ${this.state.choices.length * 270}px"
                  >
                    ${this.state.choices.map((c, i) => {
                      return html`
                        <li
                          style="width:270px; min-height: 300px;"
                          class="${this.state.selectedAnswers.has(i)
                            ? uncenteredSelectedAnswerStyle
                            : uncenteredUnselectedAnswerStyle} relative mr3 f5 tl pointer noselect"
                          onclick="${evt => {
                            evt.preventDefault();
                            this.answerClick(i);
                            // submitAnswer(this.state.id, i);
                          }}"
                        >
                          <div
                            class="w-100 h6 flex flex-column content-stretch pb5"
                          >
                            <div class="f4 fw9 pa2 self-start">
                              ${i + 1}.
                            </div>
                            <div class="pa2 pb4">${c}</div>
                          </div>
                          <div
                            class="absolute bottom-0 flex items-stretch w-100 bt bw3 ${this.state.selectedAnswers.has(
                              i
                            )
                              ? 'b--dt-blue'
                              : 'b--navy'}"
                          >
                            ${this.state.selectedAnswers.has(i)
                              ? html`
                                  <div
                                    style="width:50px; height: 50px;"
                                    class="f2 dib dt-white bg-dt-blue justify-center flex items-center"
                                  >
                                    <img
                                      src="https://projects.theintercept.com/can-you-spot-the-terrorist/assets/check.svg"
                                    />
                                  </div>
                                `
                              : html`
                                  <div
                                    style="width:50px; height: 50px;"
                                    class="f2 dib dt-white bg-navy justify-center flex items-center"
                                  >
                                    <img
                                      src="https://projects.theintercept.com/can-you-spot-the-terrorist/assets/check.svg"
                                      style="opacity:.35"
                                    />
                                  </div>
                                `}

                            <div
                              style="width:50px; height: 50px;"
                              class="${this.state.selectedAnswers.has(i)
                                ? selectedSelectButtonStyle
                                : selectButtonStyle}"
                            >
                              ${this.state.selectedAnswers.has(i)
                                ? 'selected'
                                : 'select'}
                            </div>
                          </div>
                        </li>
                      `;
                    })}
                  </ul>
                </div>
              `}
        </div>
        <div>
          ${this.state.chosenAnswer !== undefined
            ? ''
            : html`
                <section class="${stickToBottom}">
                  <div
                    class="${unselectedAnswerStyle}"
                    onclick="${evt => {
                      // submitAnswer(this.state.id, i);
                      evt.preventDefault();
                      this.answerSubmit();
                    }}"
                  >
                    Submit
                  </div>
                </section>
              `}
          ${this.state.chosenAnswer !== undefined
            ? html`
                <section class="${stickToBottom}">
                  <div
                    class="${unselectedAnswerStyle}"
                    onclick="${() => {
                      this.nextQuestion();
                    }}"
                  >
                    Next
                  </div>
                </section>
              `
            : ''}
        </div>
      </div>
    `;
  }

  update() {
    return true;
  }
}

module.exports = MultiselectMultipleChoice;
